import { ContactSupportAction } from '@/customer/components/contact-support-action'
import { StackedLayout } from '@/customer/components/form/layouts/stacked-layout'
import { FormDescription, FormLabel } from '@/customer/components/form/primitives'
import { Textarea } from '@/customer/components/ui/textarea'

export function BookingNotes({
  id,
  value,
  onChange,
}: {
  id: string
  value: string
  onChange: (value: string) => void
}) {
  const descriptionId = `${id}-description`

  return (
    <StackedLayout
      label={
        <FormLabel htmlFor={id} required={false}>
          Anything else you want us to know?
        </FormLabel>
      }
      control={
        <Textarea
          id={id}
          aria-describedby={descriptionId}
          placeholder="e.g. gets nervous with large dogs around"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      }
      description={
        <div className="flex flex-col gap-3">
          <FormDescription id={descriptionId}>
            This field is for information about your pet only. Extra care requested in notes, such
            as vaccinations or nail clipping, will not be included in the visit. If you need a
            different appointment type or additional services, please contact our team.
          </FormDescription>
          <div className="flex justify-end">
            <ContactSupportAction />
          </div>
        </div>
      }
    />
  )
}
